






















import { Component, Vue } from "vue-property-decorator";
import PatientEditor from "@/components/Patient/PatientEditor.vue";

@Component({
  components: {
    PatientEditor,
  }
})
export class PatientEdit extends Vue {
}

export default PatientEdit;
